import React, { useState } from "react";
import { Link } from "react-router-dom";

interface IProps {
    title: string;
    link: string;
    tabNo: string;
    selectedTab: string;
    getIcon?: any;
    titleClass?: any;
}

const TabItemWithIcon: React.FunctionComponent<IProps> = (props) => {
    const [currentTab, setCurrentTab] = useState(props.selectedTab);

    function handleClick(e: any) {
        setCurrentTab(e.currentTarget.id.toString());
    }

    return (
        <li className="tab-item" role="menuitem" onClick={handleClick} id={props.tabNo} aria-label={props.title}>
            <Link
                aria-current={props.tabNo === currentTab ? "page" : "false"}
                to={props.link}
                className={"btn-default btn-tab " + (props.tabNo === currentTab ? "tab-active" : "")}
                onClick={() => window.addToDataLayer({ event: "breachIQTab " + props.title.trim })}
                tabIndex={props.tabNo === currentTab ? -1 : 0}
            >
                <span className={`btn-text ${props.titleClass}`}>{props.title}</span>
                {props.getIcon ? props.getIcon() : null}
            </Link>
        </li>
    );
};

export default TabItemWithIcon;
